import React from "react";
import UserLogo from "../../assets/img/barnet_logo.svg";
// import { Animated } from "react-animated-css";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { toEnglishNum, toPersianNum } from "../../assets/utils";
// import LoadingPage from "../../components/loadingPage/loadingPage.component";
import {
  setLoginPhoneNumber,
  setLoginPhoneNumberIsValid,
} from "../../redux/login/login.actions";
import {
  selectLoginPhoneNumber,
  selectLoginPhoneNumberIsValid,
  selectLoginStep,
} from "../../redux/login/login.selectors";
import { UserWelcomeStyled } from "./inputPhoneNumber.styles";
const InputPhoneNumber = ({
  loginPhoneNumber,
  setLoginPhoneNumber,
  setLoginPhoneNumberIsValid,
  loginPhoneNumberIsValid,

  loginStep,
}) => {
  const handle_phoneNumber_change = (e) => {
    const value = e.currentTarget.value;

    setLoginPhoneNumber(toEnglishNum(value));

    if (value.length < 11 && loginPhoneNumberIsValid) {
      setLoginPhoneNumberIsValid(false);
      return;
    }
    if (value.length === 11 && !loginPhoneNumberIsValid) {
      setLoginPhoneNumberIsValid(true);
      return;
    }
  };

  // const handle_phoneNumber_blur = (e) => {
  //   const value = e.currentTarget.value;

  //   if (value.length !== 11) setLoginPhoneNumberIsValid(false);
  //   else setLoginPhoneNumberIsValid(true);
  // };

  const WithoutLoggin = () => {
    window.location.href = `/app2/without`;
  };

  return (
    <div>
      <div>
        <div className="d-flex">
          <div className="ml-2">
            <img src={UserLogo} alt="logo" />
          </div>
          <UserWelcomeStyled>
            <span style={{ fontSize: "16px", fontWeight: "999" }}>
              کاربر عزیز
            </span>
            <span style={{ fontSize: "14px", fontWeight: "999" }}>
              به بارنت خوش آمدید
            </span>
          </UserWelcomeStyled>
        </div>
        {loginStep === 0 && (
          <div className="font-weight-bold font-size--3">
            لطفا شماره موبایل خود را وارد کنید:
          </div>
        )}
        <div>
          <input
            onChange={(e) => handle_phoneNumber_change(e)}
            // onBlur={(e) => handle_phoneNumber_blur(e)}
            className={`input--custom w-100 LoginPhoneFirstStep__input-phone ${
              loginPhoneNumberIsValid ? "" : "input--invalid"
            }`}
            style={{ height: "48px", letterSpacing: ".1em" }}
            type="tel"
            name=""
            id=""
            maxLength="11"
            // minLength="11"
            value={toPersianNum(loginPhoneNumber)}
            // required
            readOnly={loginStep > 0}
          />
        </div>
      </div>
      <div
        className="d-flex justify-content-center mt-5 "
        style={{ fontSize: "14px",fontWeight: "999", color: "#ffbf1d" }}
      >
        <button onClick={() => WithoutLoggin()}>ورود بدون شماره تلفن</button>
      </div>
    </div>
  );
};
const mapStateToProps = createStructuredSelector({
  loginPhoneNumber: selectLoginPhoneNumber,
  loginPhoneNumberIsValid: selectLoginPhoneNumberIsValid,
  loginStep: selectLoginStep,
});

const mapDispatchToProps = (dispatch) => ({
  setLoginPhoneNumber: (x) => dispatch(setLoginPhoneNumber(x)),
  setLoginPhoneNumberIsValid: (x) => dispatch(setLoginPhoneNumberIsValid(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InputPhoneNumber);
